import { Routes } from '@angular/router';
import { HelpfileComponent } from './helpfile.component';
//import { HelpIntroductionComponent } from './help-introduction/help-introduction.component';
import { HelpCharitiesComponent } from './help-charities/help-charities.component';
import { HelpQuickreferenceComponent } from './help-quickreference/help-quickreference.component';
import { HelpReportComponent } from './help.report/help.report.component';
import { HelpAccountingPeriodComponent } from './help-accounting-period/help-accounting-period.component';
import { HelpSubmissionHistoryComponent } from './help.submission-history/help.submission-history.component';
import { HelpSettingsComponent } from './help.settings/help.settings.component';
import HelpLicenceComponent from './help-licence/help-licence.component';
import { UserguideComponent } from './userguide/userguide.component';
import { CopyrightComponent } from './copyright/copyright.component';
import { HelpIntroductionComponent } from './help-introduction/help-introduction.component';

export const helpfileroutes: Routes = [
  {
    path: '',
    title: 'Andica Charity Accounts Software',
    component: HelpfileComponent,
    children: [
      {
        path: '',
        redirectTo: 'copyright',
        pathMatch: 'full'
      },
      //{
      //  path: 'userguide',
      //  title: 'Andica Charity Accounts',
      //  component: UserguideComponent
      //},
      {
        path: 'copyright',
        title: 'Andica Charity Accounts',
        component: CopyrightComponent
      },
      {
        path: 'licence',
        title: 'Andica Charity Accounts',
        component: HelpLicenceComponent
      },
      {
        path: 'introduction',
        title: 'Andica Charity Accounts',
        component: HelpIntroductionComponent
      },
      {
        path: 'Charities',
        title: 'Andica Charity Accounts',
        component: HelpCharitiesComponent
      },
      {
        path: 'Quickreference',
        title: 'Andica Charity Accounts',
        component: HelpQuickreferenceComponent
      },
      {
        path: 'reportsguidedataset',
        title: 'Andica Charity Accounts',
        component: HelpReportComponent
      },
      {
        path: 'accounting-period',
        title: 'Andica Charity Accounts',
        component: HelpAccountingPeriodComponent
      },
      {
        path: 'submissionhistorysdata',
        title: 'Andica Charity Accounts',
        component: HelpSubmissionHistoryComponent
      },
      {
        path: 'settingshelp',
        title: 'Andica Charity Accounts',
        component: HelpSettingsComponent
      }
    ]
  }
];
